<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  offerBuckets: { type: Array, default: () => [] },
  offerBucket: { type: String, default: '' },
});

const emit = defineEmits(['select']);

const selectOfferBucket = value => emit('select', value);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="border-b border-lais-border px-4 sm:px-6 lg:px-10">
    <div class="flex items-center gap-6 overflow-x-auto no-scrollbar">
      <button
        v-for="bucket in offerBuckets"
        :key="bucket.value"
        type="button"
        class="relative py-3 text-[14px] font-semibold transition-colors whitespace-nowrap"
        :class="
          offerBucket === bucket.value
            ? 'text-lais-primary'
            : 'text-lais-text-muted hover:text-lais-text-body'
        "
        @click="selectOfferBucket(bucket.value)"
      >
        {{ bucket.label }}
        <span
          v-if="offerBucket === bucket.value"
          class="absolute bottom-0 left-0 right-0 h-[3px] rounded-t bg-lais-primary"
        />
      </button>
    </div>
  </div>
</template>
